module.exports = __webpack_public_path__ + "static/media/fav-img2.69a3d8aa.png";